export default {
      id: "sli-moon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-moon",
      toString: function () {
        return this.url;
      }
    }